import { baseQuery } from '../baseQuery';

type PutAttributePayload = {
  serviceId: number;
  attributes: {
    field: string;
    value: string;
  }[];
};

export const putServiceAttributes = async ({ serviceId, attributes }: PutAttributePayload) => {
  const { data } = await baseQuery('service-attributes', {
    type: 'PUT',
    body: {
      service_id: serviceId,
      attributes,
    },
  });

  return data;
};
